import { CartLinesUpdateEvent } from '@shopify/events';

const MONK_CART_REFRESH_SOURCE_ID = 'monk-cart-refresh';

/** @type {Promise<void> | null} */
let activeRefreshPromise = null;

async function refreshCartFromMonk() {
  if (activeRefreshPromise) return activeRefreshPromise;

  activeRefreshPromise = (async () => {
    const response = await fetch(`${Theme.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Failed to refresh cart after Monk update: ${response.status}`);
    }

    const cart = await response.json();
    const deferredCartUpdate = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'update',
        context: 'standard-action',
        lines: cart.items.map((item) => ({
          id: item.key || item.id,
          quantity: item.quantity,
        })),
        promise: deferredCartUpdate.promise,
        detail: {
          source: MONK_CART_REFRESH_SOURCE_ID,
          sourceId: MONK_CART_REFRESH_SOURCE_ID,
        },
      })
    );
    deferredCartUpdate.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        source: MONK_CART_REFRESH_SOURCE_ID,
        sourceId: MONK_CART_REFRESH_SOURCE_ID,
        itemCount: cart.item_count,
        items: cart.items,
        didError: false,
      },
    });
  })();

  try {
    await activeRefreshPromise;
  } finally {
    activeRefreshPromise = null;
  }
}

document.addEventListener('cart:refresh', () => {
  refreshCartFromMonk().catch((error) => {
    console.error(error);
  });
});
